import { render } from "./settings-site.vue?vue&type=template&id=4485ec1a"
import script from "./settings-site.vue?vue&type=script&lang=js"
export * from "./settings-site.vue?vue&type=script&lang=js"

import "./settings-site.vue?vue&type=style&index=0&id=4485ec1a&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__